import { Command, NetworkRequest } from "../../sdkStructs.ts";

export function convertCommandsToIO(cli_commands: Command[]) {
  const type: "command" | "request" = "command";
  return cli_commands.map((command) => {
    return {
      type: type,
      input: command.Command,
      output: command.Output,
      timestamp: command.Timestamp,
      id: command.ID,
    };
  });
}

export function convertRequestsToIO(network_requests: NetworkRequest[]) {
  const type: "command" | "request" = "request";
  return network_requests.map((request) => {
    return {
      type: type,
      input: request.Request,
      output: request.Response,
      timestamp: request.Timestamp,
      id: request.ID,
    };
  });
}
